import Repository from '../../../../../foundation/repository/Repository';
import User from '../aggregates/user/User';
import ApiData from '../../../../../foundation/repository/ApiData';
import Preferences from '../aggregates/user/Preferences';
import Name from '../aggregates/user/Name';
import Registry from '../../../../global/Registry';
import Organization from '../../../organizations/domain/aggregates/organization/Organization';
import EntityId from '../../../../../foundation/domain/EntityId';

export default class UserRepository extends Repository<User> {

	public mapObject (data: ApiData) {
		const preferencesData = data.navigate('preferences');
		const nameData = data.navigate('name');

		const organization = data.isNull('organization') ? null : Registry.getInstance().organizationRepository.mapOne(data.getData('organization'));

		return new User(
			data.id<User>('id'),
			data.stringOrNull('emailAddress'),
			data.stringOrNull('username'),
			organization ? organization.getId() : EntityId.create<Organization>(),
			nameData.isNull() ? null : new Name(nameData.string('firstName'), nameData.string('lastName')),
			new Preferences(preferencesData.booleanOrNull('reviewReminders'))
		);
	}

	public getMe () {
		return this.getAll()[0];
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/users/domain/repositories/UserRepository.ts